import { RG_TYPE as f } from "@project-rouge/rg-core";
import { getRoofFacadePerimeter as c } from "../3d/boundary/internal/index.js";
import { getLevelGIAPolygon as m } from "../geometry-utils/internal/index.js";
import { getLevelGEAPolygon as s } from "../geometry-utils/internal/index2.js";
import { getBuildingProjectionPolygon as y } from "../geometry-utils/internal/index3.js";
function R(e, t) {
  e.data.groundProjectionPolygon = y(e);
  const r = /* @__PURE__ */ new Map();
  for (const o of e.data.levels) {
    if (o.isRoof) {
      o.roofFacadePerimeter = c(e, o);
      continue;
    }
    const l = e.children.filter((a) => a.type !== f.Facade && a.data.levelId === o.uuid), n = P(l);
    r.has(n) || r.set(n, {
      gia: m(e, o, t),
      gea: s(e, o)
    });
    const { gea: g, gia: i } = r.get(n);
    o.geaPolygon = g, o.giaPolygon = i;
  }
}
function P(e) {
  return `${e.length}|${e.map((t) => `${t.type}|${t.size[0]}|${t.size[2]}`).join("|")}`;
}
export {
  R as setBuildingPolys
};
//# sourceMappingURL=index31.js.map
